'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getNetworkDownAlert = undefined;

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

var _alertTypes = require('./constants/alertTypes');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getNetworkDownAlert = exports.getNetworkDownAlert = function getNetworkDownAlert() {
  return {
    id: _alertTypes.NETWORK_OFFLINE_ALERT_ID,
    type: 'danger',
    titleText: _I18n2.default.text('conversationsUI.alerts.pubNubStatus.visiblyOffline.title'),
    message: _I18n2.default.text('conversationsUI.alerts.pubNubStatus.visiblyOffline.description'),
    sticky: true
  };
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-internal-components/static-1.4266/js/connection-alerts/getNetworkDownAlert.js
// module id = 803
// module chunks = 2 3